const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		style: 'extendedFilters',
		mode: 'default',
		supportOnScrollLimits: true,
		reloadDataOnFilterReset: false,
		searchDelay: 500,
		defaultTreeOperationsOnFirstTree: false,
		autoOpenLevel: 2,
		preventGUIHandlingOfMaxOpenedLevelOnInit: true,
		preSelectBySortIndicator: true,
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'routeTrees',
				'routeTree'
			]
		},
		// doubleClickButtonData: {
		// 	fieldType: 'edit',
		// 	context: 'routeContent'
		// },
		// doubleClickAbortActions: [
		// 	'node_home_select',
		// 	'node_lang_select',
		// 	'node_page_select'
		// ]
		nodeActionMapping: {
			defaultContext: {
				lang: 'route',
				home: 'route',
				page: 'route'
			},
			defaultBaseActions: {
				select: {
					lang: 'showEdit_route',
					home: 'showEdit_route',
					page: 'showEdit_route'
					// lang: 'showEdit_route',
					// home: 'edit_routeContent',
					// page: 'edit_routeContent'
				},
				deselect: {
					lang: 'showEdit_route',
					home: 'showEdit_route',
					page: 'showEdit_route'
					// lang: 'showEdit_route',
					// home: 'edit_routeContent',
					// page: 'edit_routeContent'
				}
			}
		}
	},

	model: {
		highlightRouteIDs: {},
		parentNodeStatesPerType: {},
		sortIndicatorsPerType: {},
		searchTerm: '',
		waitForExternalFilters: true,
	},

	methods: {
		prepare: function(storage){
			var maxOpenedLevelOnInit = ((((((storage || {}).app || {}).service || {}).config || {}).customizations || {}).routeTrees || {}).maxOpenedLevelOnInit;
			if (maxOpenedLevelOnInit !== undefined) {
				this.config.maxOpenedLevelOnInit = maxOpenedLevelOnInit;
			}
			var autoOpenLevel = ((((((storage || {}).app || {}).service || {}).config || {}).customizations || {}).routeTrees || {}).autoOpenLevel;
			if (autoOpenLevel !== undefined) {
				this.config.autoOpenLevel = autoOpenLevel;
			}

			this.config.childTreeConfig.showLanguageConnectionWarnings = this.hasAccessTo('usage:languages:showRouteLanguageDetails')
			this.config.childTreeConfig.showLayoutWarnings = this.hasAccessTo('usage:routeTrees:showLayoutWarnings')
		},

		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var langNode        = buttonMode === 'rootLang';
			var rootNode        = buttonMode === 'root' || langNode;
			var insertWithin    = buttonMode === 'within';
			var insertAfter     = buttonMode === 'after';

			if(this.actions[baseActionKey]){
				var nodeData;
				var sortMeta = {};
				var parentRouteID;

				if(rootNode){
					parentRouteID = 0;
				}
				else {
					nodeData        	= this.getSelectedNodeData();
					parentRouteID   	= nodeData.parentRouteID;
					sortMeta.targetID 	= nodeData.id;
					sortMeta.position 	= 'before';
					if(insertAfter){
						sortMeta.position = 'after';
					}
					else if(insertWithin){
						parentRouteID = nodeData.id;
						sortMeta.position = 'child';
					}
				}

				return this.performAction(
					this.prepareAction(baseActionKey, undefined, undefined, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														config: {
															useCase: (rootNode ? 'rootNode' : undefined)
														},
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		type:           (langNode ? 'language' : undefined),
																		parentRouteID:  parentRouteID,
																		sortMeta: 		sortMeta
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					})
				);
			}

			return utils.promise.reject();
		},

		showDuplicateOptions: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			const nodeData    = this.getSelectedNodeData();
			const rootNode    = nodeData.parentRouteID == 0;

			if(this.actions[baseActionKey] && nodeData.id){
				return this.performAndStoreAction(
					'showDuplicateOptions_inEffect',
					this.prepareAction(baseActionKey, undefined, {
						highlightRouteIDs: {
							[nodeData.id]: true
						},
						duplicationSource: {
							nodeData,
							rootNode
						}
					}, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		target: {
																			[nodeData.id]: {
																				routeID: nodeData.id
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					})
				)
			}
		},

		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			baseActionKey 	= baseActionKey || 'showDuplicate_route'
			const nodeData	= this.getSelectedNodeData();
			const rootNode  = nodeData.parentRouteID == 0;
			const duplicationOptions = (additionalData || {}).duplicationOptions || {}

			if(this.actions[baseActionKey] && nodeData.id){

				return this.performAndStoreAction(
					'showDuplicate_inEffect',
					this.prepareAction(baseActionKey, nodeData.id, undefined, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														config: {
															useCase: (rootNode ? 'rootNode' : undefined)
														},
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		path:           undefined,
																		isHome: 		duplicationOptions.targetHomeNodeIsValid ? nodeData.isHome || false : false,
																		sortMeta: {
																			targetID: 	(duplicationOptions.target || {}).routeID || nodeData.id,
																			position: 	'after'
																		},
																		duplicateMeta: duplicationOptions
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		showProtocol: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			baseActionKey 		= 'showProtocol'
			const actionKey		= baseActionKey + '_inEffect';
			const nodeData    	= this.getSelectedNodeData();
			const entityID 		= nodeData.id
			const entityType 	= 'route'
			const entityContext	= 'route'

			if(entityID){
				return this.performAndStoreAction(
					actionKey,
					this.prepareAction(baseActionKey, undefined, {
						protocol: {
							entityID,
							entityType,
							entityContext
						}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		open: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			const storage = this.getStorage()
			var webServiceUrl = ((storage.app || {}).webService || {}).url;
			if(webServiceUrl){
				var nodeIndex = this.getSelectedNodeIndex();
				var nodeData = this.getNodeData(nodeIndex) || {};

				if(nodeData.path){
					window.open(webServiceUrl + nodeData.path, '_blank');
				} else {
					console.error('OPEN_ROUTE_PATH_MISSING');
				}
			} else {
				console.error('OPEN_ROUTE_WEB_SERVICE_MISSING');
			}
		},

		edit: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			var self = this;
			var nodeIndex = this.getSelectedNodeIndex();
			var nodeData = this.getNodeData(nodeIndex);
			var actionKey = baseActionKey;
			var routeID = nodeData.id || nodeData._primaryKey;

			if(buttonMode === 'asHome'){
				if(routeID){

					// set as noHome if necessary
					if(nodeData.isHome){
						return self.performAction(
							self.prepareAction(baseActionKey + '_asNonHome', routeID)
						).then(function(context){
							self.refreshTrees(true);
							return context;
						});
					}

					if(!this.isHomeAllowed(nodeIndex)){
						return this.performAction(
							this.prepareAction('message', undefined, {
								messageDisplay: {
									message: 'Diese Seite kann nicht als Startseite verwendet werden.'
								}
							})
						).then(function(context){
							return utils.promise.resolve({
								response: {
									asHomeNotAllowed: true
								}
							});
						});
					}
					else {
						return self.performAction(
							self.prepareAction(baseActionKey + '_asHome', routeID)
						).then(function(context){
							self.refreshTrees(true);
							return context;
						});
					}
				}
			}
			else if(buttonMode === 'setLayout'){
				return this.performAction(this.prepareAction(baseActionKey, undefined, undefined, {
					source: {
						submit: {
							data: {
								data: {
									attributes: {
										templateID: data.templateID,
										id:         data.routeID
									}
								}
							}
						}
					}
				}));
			}
			else {
				let actionExtension
				if(this.config.mode === 'chooser'){
					actionKey += '_moveToSelector_InEffect';
				} else {
					actionKey += '_' + (nodeData._primaryKey || nodeData.id);
					actionExtension = {
						source: {
							tabContent: {
								componentData: {
									config: {
										startWithRegisterSecret: (data || {}).startWithRegisterSecret || 'routeContent'
									}
								}
							}
						}
					}
				}

				// re-perform action if necessary
				if(this.config.mode !== 'chooser' && this.actions[actionKey]){
					return this.performAction(actionKey, {
						focusTabSecret: (data || {}).startWithRegisterSecret || 'routeContent'
					});
				}
				else if(this.actions[baseActionKey]){
					var node = this.getNode(nodeIndex);
					return this.performAndStoreAction(
						actionKey,
						this.prepareAction(baseActionKey, undefined, {
							routeTreeParent: utils.replace(nodeData, { resourceID: nodeData._primaryKey || nodeData.id }),
							tabOptions: {
								title: node.text,
								icon: node.icon
							}
						}, actionExtension),
						this.config.mode === 'chooser'
					);
				}
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.route.title'),
					message:    storage.__('hint.delete.really.route.message')
				}
			).then(function(context){
				if(context.decision.type === 'yes'){
					var nodeIndex = self.getSelectedNodeIndex();
					var nodeID = self.getSelectedNodeID();
					self.deselectActiveNode();
					if(nodeID != undefined && self.actions[baseActionKey]){
						self.setClosestNodeAsReady(nodeIndex);
						self.updateScrollTop();
						if(buttonContext === 'route'){
							return self.performAction(
								self.prepareAction(baseActionKey, nodeID)
							).then(function(context){
								self.refreshTrees(true);
								self.callHandler('onDeleteRoute', [nodeID]);
								return context;
							});
						}
					}
				}

				return utils.promise.reject();
			});
		},

		cut: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var targetNodeIndex = (additionalData || {}).targetNodeIndex;
			if(targetNodeIndex){
				var targetNodeData = this.getNodeData(targetNodeIndex);
				if(targetNodeData){
					this.setSpecialNodeData('cutPaste', { nodeData: targetNodeData });
					getComponent('statusController').addPanel('status.done.cut');
				}
			}

			return utils.promise.resolve();
		},

		paste: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData) {
			var sourceNodeData = (this.getSpecialNodeData('cutPaste') || {}).nodeData;
			var targetNodeIndex = (additionalData || {}).targetNodeIndex;
			if(sourceNodeData && targetNodeIndex){
				var targetNodeData = this.getNodeData(targetNodeIndex);
				if(sourceNodeData.id && sourceNodeData.nameSEO && targetNodeData.id && sourceNodeData.id != targetNodeData.id && (
					buttonMode === 'before' ||
					buttonMode === 'child' ||
					buttonMode === 'after'
				)){
					var movementAttributes = {
						nameSEO: 		sourceNodeData.nameSEO,
						parentRouteID: 	targetNodeData.parentRouteID,
						sort: 			targetNodeData.sort,
						sortMeta: {
							targetID: 	targetNodeData.id,
							position: 	buttonMode
						}
					};

					if(buttonMode === 'child'){
						movementAttributes.parentRouteID = targetNodeData.id;
						delete movementAttributes.sortMeta.targetID;
					}

					// set layout if necessary
					if(!movementAttributes.parentRouteID){
						movementAttributes.templateID = sourceNodeData.templateID || targetNodeData.templateID;
					}

					return this.performMove(sourceNodeData.id, movementAttributes, {
						id: 	targetNodeData.id,
						index: 	targetNodeData.index,
						sort: 	targetNodeData.sort
					});
				}
			}

			return utils.promise.resolve();
		},

		connectLayout: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData = this.getSelectedNodeData();
			if(this.actions[baseActionKey]) {
				return this.performAndStoreAction('connectLayoutInCharge', this.prepareAction(baseActionKey, undefined, undefined, {
					source: {
						load: {
							componentData: {
								actions: {
									loadContent: {
										source: {
											load: {
												componentData: {
													config: {
														readyNodeID:        nodeData.templateID,
														readyNodeContext:   'layout'
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}), true);
			}

			return utils.promise.reject();
		},

		connectLanguage: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			const nodeData = this.getSelectedNodeData();
			const routeID = nodeData.routeID || nodeData.id;

			if(routeID) {
				return this.performAndStoreAction(
					`${baseActionKey}_inEffect`,
					this.prepareAction(baseActionKey, undefined, {
						routeLanguageConnector: {
							routeID
						}
					}),
					true
				)
			}

			return utils.promise.reject();
		},

		/**
		 * perform PATCH on route for moving
		 *
		 * @param primaryKey				number - primaryKey of route
		 * @param movementAttributes		{} - attributes to send to the api
		 * @param backupSortIndicator		{} - definition of sortIndicator-backup
		 * @returns Promise
		 */
		performMove: function(primaryKey, movementAttributes, backupSortIndicator){
			var self = this;

			return self.performAction(
				self.prepareAction('move_route', primaryKey, undefined, {
					source: {
						submit: {
							data: {
								data: {
									attributes: movementAttributes
								}
							}
						}
					}
				})
			).then(function(context){
				self.setSpecialNodeData('cutPaste');
				getComponent('statusController').addPanel('status.done.paste');

				var data 		= (context.response || {}).data || {};
				var attributes 	= data.attributes || {};
				if(backupSortIndicator){
					// backup position of movement target if possible to prevent offsetTop measurement problems during movements.
					self.backupSortIndicator(backupSortIndicator.id, backupSortIndicator.sort, `#${backupSortIndicator.index}`);
				}

				// choose layout if necessary
				if(!attributes.parentRouteID && !attributes.templateID){
					return context.component.performAndStoreAction('connectLayoutInCharge',
						context.component.prepareAction('connectLayout_route')
					).then(function(context){
						self.refreshTrees();
					});
				}
				else {
					// refresh to get the lists up to date after movement
					self.refreshTrees(true);
				}

			}).fail(function(error){
				// prevent wrong gui state from being displayed
				self.setSpecialNodeData('cutPaste');
				self.refreshTrees();
			});
		},

		getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			if(actionKey === 'refreshResources'){
				this.checkOnceForFilterComponentPresets();

				var state = this.getTypeDependentState();
				resourceFilters = resourceFilters || {};
				resourceFilters.autoOpenLevel = this.config.autoOpenLevel || 1;
				if((attachTriggerOptions || {}).postBuildAction){
					resourceFilters.sortIndicator = state.sortIndicator.lastUsed;
				} else {
					resourceFilters.sortIndicator = state.sortIndicator.sort;
					state.sortIndicator.lastUsed = resourceFilters.sortIndicator;
				}
				var filterParams = this.model.filterParams || {};
				resourceFilters.search = {
					term: filterParams.searchTerm || '',
					type: state.type,
					tags: filterParams.tags,
					tags_tagConnection: filterParams.tags_tagConnection,
				};

				if(filterParams.limitByCheckboxSelection && Object.keys(this.model.dirtyAssignedRoutes || {}).length > 0){
					var routeID = 0
					var routeIDs = {}
					var routeFound = false
					for(var index in this.model.dirtyAssignedRoutes){
						if((routeID = ((this.model.dirtyAssignedRoutes[index] || {}).routeID))){
							routeIDs[routeID] = true
							routeFound = true
						}
					}

					if(routeFound){
						resourceFilters.search.limitToRouteIDs = Object.keys(routeIDs)
					}
				}

				resourceFilters.nodesState = [];
				var parentNodes = Object.keys(state.parentNodeStates || {});
				for(var parentRouteID of parentNodes){
					resourceFilters.nodesState.push({
						id: 	parentRouteID,
						open: 	state.parentNodeStates[parentRouteID]
					});
				}
			}

			return resourceFilters
		},

		checkOnceForFilterComponentPresets(){
			// NOTE: overwrite if necessary
		},

		sanitizeResources: function(storage){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Routen...',
						tree: [],
						nodes: {}
					}
				]
			};
			var trees = resources.trees;

			if(this.resourceData.data) {
				this.resetNodeMappings();
				this.config.extendedTreeView = this.hasRoleOption('extendedTreeView');
				this.config.filterForRouteTypesGranted = this.hasRoleOption('filterForRouteTypesGranted');
				this.config.reloadDataOnFilterReset = !this.config.filterForRouteTypesGranted;

				var elements = {};
				var mapping = {};
				var counter = 0;
				var parent;
				var state = this.getTypeDependentState();

				var inheritedRouteCategories = utils.prepareTagCategoryInheritanceList(this.resourceData, this.resourceData.routeTags, 'parentRouteID');

				// NOTE:    this element preparation phase is necessary in case of routes which are received after the next root-route.
				//          e.g., A; B; AA
				// assign tree identifier to each element
				utils.forEach(this.resourceData.data, function (routeData, routeIndex) {
					var route = routeData.attributes;
					var routeID = route[routeData.primaryKey];
					route.id = route.id || routeID;

					// prepare routes categories if they are nav-categories
					route.categories = {};
					utils.prepareCategories(route.categories, ((routeData.children || {}).cms_entities_categories || {}).data || [], storage, inheritedRouteCategories[route.id] || {}, self.scope);
					utils.forEachReverse(route.categories, function(category, categoryIndex){
						if(!category.tagScopes.nav || (category.turnedOff && !category.turnedOffTagCategoryManagement)){
							delete route.categories[categoryIndex]
						}
					})

					// build strange mapping to prevent sort issues.
					mapping[route.id] = route.sort + '-' + route.id;
					route.treeIndex = 0;
					route.index = self.transformIDToIndex(route.id, 'route', route.treeIndex, counter);
					counter++;
					elements[mapping[route.id]] = route;
				});

				// build jstree trees
				var additionalClasses = [];
				var additionalLiClasses = [];
				utils.forEach(elements, function (route) {
					resources.initialized = true;
					parent = '#';

					additionalClasses = [];
					additionalLiClasses = [];
					if(route.id && (self.model.highlightRouteIDs || {})[route.id])	additionalClasses.push('state_highlighted');
					if(route.status === 'preview')									additionalClasses.push('state_preview');
					else if(route.status === 'inactive')							additionalClasses.push('state_inactive');
					if(!route.visibleInPage)										additionalLiClasses.push('state_invisible');
					if(route.matching)												additionalClasses.push('jstree-search');

					if (route.type === 'root') {}
					else if (route.type === 'language') {
						trees[route.treeIndex].tree.push({
							id: route.index,
							parent: parent,
							text: route.path + (self.config.extendedTreeView ? ' [#' + route.id + ' - ' + route.sort + ']' : ''),
							icon: 'flag-icon flag-icon-' + (route.langCode != undefined ? route.langCode.split('-')[1] : ''),
							type: 'lang',
							state: {
								opened: route.hasChildrenInPage,
								disabled: false,
								selected: (self.config.preSelectBySortIndicator && self.model.refreshDataInEffect && !self.config.readyNodeID && state.sortIndicator.selectedID === route.routeID)
							},
							children: route.hasChildren && !route.hasChildrenInPage ? true : [],
							li_attr: {
								class: additionalLiClasses.join(' ')
							},
							a_attr: {
								class: additionalClasses.join(' ')
							},
							resource: route
						});
						trees[route.treeIndex].nodes[route.index] = route;
					} else {
						if(!utils.isEmpty(route.parentRouteID)){
							if(mapping[route.parentRouteID] && elements[mapping[route.parentRouteID]]){
								parent = elements[mapping[route.parentRouteID]].index;
							}
							if(!parent) parent = '#';
						}

						trees[route.treeIndex].tree.push({
							id: route.index,
							parent: parent,
							text: route.name + (self.config.extendedTreeView ? ' [#' + route.id + ' - ' + route.sort + ']' : ''),
							type: route.isHome ? 'home' : 'page',
							state: {
								opened: route.hasChildrenInPage,
								disabled: false,
								selected: (self.config.preSelectBySortIndicator && self.model.refreshDataInEffect && !self.config.readyNodeID && state.sortIndicator.selectedID === route.routeID)
							},
							children: route.hasChildren && !route.hasChildrenInPage ? true : [],
							li_attr: {
								class: additionalLiClasses.join(' '),
								title: route.path
							},
							a_attr: {
								class: additionalClasses.join(' ')
							},
							resource: route
						});
						trees[route.treeIndex].nodes[route.index] = route;
					}
				});

				this.resourceData.trees = resources.trees;
				this.resourceData.initialized = resources.initialized;
			}
		},

		treeCoreData: function(treeIndex, object, callback){
			var resource = ((object || {}).original || {}).resource || {};
			var routeID = resource.routeID;
			var treeData = (this.resourceData.trees || [])[treeIndex || -1] || {}
			var state = this.getTypeDependentState();
			if(treeData.tree){
				if(routeID){
					state.parentNodeStates[routeID] = 1
					this.backupSortIndicator(routeID, resource.sort, '#' + object.a_attr.id);
					this.refreshData();
				} else {
					callback.call(this, treeData.tree)
				}
			} else {
				callback.call(this, [])
			}
		},

		onTreeAction: function (data) {
			var self = this;
			var node = (((data || {}).onTreeActionOptions || {}).eventData || {}).node || {};
			var resource = (node.original || {}).resource || {};
			var routeID = resource.routeID;

			switch (data.onTreeActionOptions.eventType) {
				case 'ready.jstree':
					this.model.refreshDataInEffect = false;
					this.restoreSortIndicator(true);
					break;

				case 'refresh.jstree':
					var numberOfElements = 0;
					for(var treeContainer of this.resourceData.trees || []){
						numberOfElements += (treeContainer.tree || []).length
					}
					if(numberOfElements === 0){
						this.$.addClass('showEmpty');
					} else {
						this.$.removeClass('showEmpty');
					}

					this.restoreSortIndicator();
					this.model.onScrollLimitReached = false;
					// reset height after preventing scroll-bar-flickering between close_node and lazyload next nodes.
					$(data.onTreeActionOptions.event.target).height('');
					this.model.refreshDataInEffect = false;

					// select newNode if necessary
					if(this.config.selectNewNodeAfterRefresh && this.config.readyNodeID !== undefined){
						if(this.selectNodeByID(self.config.readyNodeID, self.config.readyNodeContext, undefined, true)){
							delete this.config.readyNodeID;
							return;
						}
					}
					break;

				case 'move_node.jstree':
					var moveEntry = data.onTreeActionOptions.eventData.node;
					var moveEntryContext = this.getNodeContext(moveEntry.id);
					var actionKey = data.onTreeActionOptions.operation + '_' + moveEntryContext;
					if(this.actions[actionKey]){
						var moveTreeComponentIndex = this.getNodeTreeComponentIndex(moveEntry.id);
						var moveNode = this.getNodeData(moveEntry.id, moveTreeComponentIndex);
						var newInParentPosition = data.onTreeActionOptions.eventData.position;
						var newParentEntry, newParentNode, newParentTreeComponentIndex;
						var movementAttributes;
						if(moveEntry.parent && moveEntry.parent != '#'){
							newParentTreeComponentIndex = this.getNodeTreeComponentIndex(moveEntry.parent);
							newParentEntry = this.getNode(moveEntry.parent, newParentTreeComponentIndex);
							newParentNode = this.getNodeData(moveEntry.parent, newParentTreeComponentIndex);
						}

						var backupSortIndicator = {
							id: 	moveNode.id,
							index: 	moveNode.index,
							sort: 	moveNode.sort
						};

						if(moveEntryContext === 'route'){
							movementAttributes = {
								parentRouteID:  0,
								sort:           undefined
							};

							// set layout in case of move from non-root to root
							if(!newParentNode && !utils.isEmpty(moveNode.parentRouteID)){
								movementAttributes.templateID = moveNode.templateID;
							}

							// NOTE: send seo name in order to update the path if necessary
							if(
								// moved from non-root to root
								(!newParentNode && !utils.isEmpty(moveNode.parentRouteID))
								||
								// moved from one parent (or root) to another parent
								(newParentNode && moveNode.parentRouteID != newParentNode.id)
							){
								movementAttributes.nameSEO = moveNode.nameSEO;
							}

							// estimate right parent id
							if(newParentNode){
								movementAttributes.parentRouteID = newParentNode.id;
								backupSortIndicator = {
									id: 	newParentNode.id,
									index: 	newParentNode.index,
									sort: 	newParentNode.sort
								};
							}

							// estimate right sort
							movementAttributes.sortMeta = {
								position: 'after'
							};
							// operation: child
							if(newInParentPosition === 0 && newParentNode && newParentNode.id !== moveNode.parentRouteID){
								movementAttributes.sort = newParentNode.sort;
								movementAttributes.sortMeta.position = 'child';

							} else {
								// operation: first position in parent
								if(newInParentPosition === 0){
									movementAttributes.sortMeta.position = 'before';
								}
								// operation: after target
								else {
									newInParentPosition--;
								}
								var targetIndex = this.getPositionIndex(moveEntry.parent, newInParentPosition, function(nodeEntry, nodeData){
									return nodeEntry.id != moveEntry.id;
								}, newParentTreeComponentIndex || moveTreeComponentIndex)
								var targetNode = this.getNodeData(targetIndex, newParentTreeComponentIndex || moveTreeComponentIndex);
								movementAttributes.sort = targetNode.sort;
								movementAttributes.sortMeta.targetID = targetNode.id;

								backupSortIndicator = {
									id: 	targetNode.id,
									index: 	targetIndex,
									sort: 	targetNode.sort
								};
							}
						}

						if(movementAttributes){
							this.performMove(moveNode.id, movementAttributes, backupSortIndicator)
						}
						else {
							self.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', ' + moveEntryContext);
						}
					}
					else {
						self.refreshTrees();
						throw new Error('ACTION NOT FOUND: ' + actionKey);
					}
					break;

				case 'select_node.jstree':
					// show page actions if necessary
					this.$.find('.routeTreeActions').show();
					if(routeID){
						this.backupSortIndicator(routeID, resource.sort, '#' + node.a_attr.id, true);
					}
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find('.routeTreeActions').hide();
					break;

				case 'close_node.jstree':
					// fix height to prevent scroll-bar-flickering between close_node and lazyload next nodes.
					var state = this.getTypeDependentState();
					var $tree = $(data.onTreeActionOptions.event.target);
					var height = $tree.height();
					$tree.height(height);

					// hide page actions if necessary
					if(routeID){
						state.parentNodeStates[routeID] = 0;
						this.backupSortIndicator(routeID, resource.sort, '#' + node.a_attr.id);
						this.refreshData();
					}
					break;
			}
		},

		/**
		 * this function returns true if the node identified by the given nodeIndex is allowed to be tagged as isHome.
		 * NOTE: this function will work only if the iterative jstree format will be used (parent flag not children flag)
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @returns boolean
		 */
		isHomeAllowed: function(nodeIndex){
			var rootNode = this.getRootParentOfNode(nodeIndex);
			var langRouteAllowed = true;
			if(rootNode.nodeData.type === 'language'){
				// check if lang path is used in service config
				langRouteAllowed = false;
				if(rootNode.entry.id != nodeIndex){
					const storage = this.getStorage()
					for(const {langCode, lang} of Object.entries(utils.language.getConfig(storage).available)){
						if(!utils.isEmpty(lang.route) && rootNode.nodeData.path.indexOf(lang.route) === 0){
							langRouteAllowed = true
							break
						}
					}
				}
			}

			return langRouteAllowed;
		},

		/**
		 * returns the actual state according to the chosen type.
		 * different routeTypes like mailing-routes and common-routes (pages or languages) have different states according to their scroll position, ...
		 *
		 * @returns {{sortIndicator: *, parentNodeStates: *, type: string}}
		 */
		getTypeDependentState: function(){
			const type = (this.model.filterParams || {}).type || 'common';

			this.model.sortIndicatorsPerType 			= this.model.sortIndicatorsPerType || {};
			this.model.sortIndicatorsPerType[type] 		= this.model.sortIndicatorsPerType[type] || {};
			this.model.parentNodeStatesPerType 			= this.model.parentNodeStatesPerType || {};
			this.model.parentNodeStatesPerType[type] 	= this.model.parentNodeStatesPerType[type] || {};

			return {
				type,
				sortIndicator: 		this.model.sortIndicatorsPerType[type],
				parentNodeStates: 	this.model.parentNodeStatesPerType[type]
			};
		},

		/**
		 * this function is used to save the current sort indicator state and is the pendant to the restoreSortIndicator method.
		 * if the userSelected flag is set to true the actual routeID will be marked as selected for future refreshes too.
		 *
		 * @param routeID		int - routeID
		 * @param sort			int - sort
		 * @param selector		string - dom-element-selector for the element which should define the scroll top
		 * @param userSelected	boolean - has the element been chosen by the user (and should therefore be kept marked as selected) or not.
		 */
		backupSortIndicator: function(routeID, sort, selector, userSelected){
			if(this.$.is(':visible')){
				var self = this;
				var state = self.getTypeDependentState();
				if(routeID){
					state.sortIndicator.selectedID 	= userSelected ? routeID : state.sortIndicator.selectedID;
					state.sortIndicator.id 			= routeID;
					state.sortIndicator.selector 	= selector;
					state.sortIndicator.sort 		= sort || 0;
					state.sortIndicator.offsetTop 	= (self.$.find(selector).offset() || {}).top || 0;
				} else if(state.selector) {
					state.sortIndicator.offsetTop 	= (self.$.find(state.sortIndicator.selector).offset() || {}).top || 0;
				}

				delete state.sortIndicator.scrollTop;
			}
		},

		/**
		 * this function restores the scroll top position according to the actual backup state and is
		 * the pendant to the backupSortIndicator() method.
		 */
		restoreSortIndicator: function(){
			if(this.$.is(':visible')){
				var self = this;
				var state = self.getTypeDependentState();
				if(state.sortIndicator.scrollTop !== undefined){
					self.find('base_trees_tree', function(routeTreeComponent){
						if((routeTreeComponent.actualParentComponent || {}).componentIndex !== self.componentIndex) return;
						routeTreeComponent.$.scrollTop(state.sortIndicator.scrollTop);
					});
					// delete state.sortIndicator.scrollTop;
				} else if(state.sortIndicator.id && state.sortIndicator.offsetTop !== undefined) {
					var sortIndicatorsNewIndex = self.getNodeIndex(state.sortIndicator.id, 'route');
					if(sortIndicatorsNewIndex){
						var $sortIndicator = self.$.find(`#${sortIndicatorsNewIndex}_anchor`);
						if($sortIndicator.length > 0){
							self.find('base_trees_tree', function(routeTreeComponent){
								if((routeTreeComponent.actualParentComponent || {}).componentIndex !== self.componentIndex) return;

								var newScrollTop = Math.max(0, routeTreeComponent.$.scrollTop() - (state.sortIndicator.offsetTop || 0) + ($sortIndicator.offset() || {}).top || 0);
								var $tree = routeTreeComponent.$.find('> .tree');
								var maxOffset = $tree.height() - routeTreeComponent.$.height();

								// provide temporary padding-bottom to prevent scroll position flickering in case the last page is shrinked by closing nodes.
								routeTreeComponent.$
									.css('padding-bottom', `${Math.max(0, newScrollTop - maxOffset)}px`)
									.scrollTop(newScrollTop)
								;
								self.model.preventNextScrollLimitCheck = false;
							});
						}
						delete state.sortIndicator.offsetTop;
					}
				} else {
					self.find('base_trees_tree', function(routeTreeComponent){
						if((routeTreeComponent.actualParentComponent || {}).componentIndex !== self.componentIndex) return;
						routeTreeComponent.$.scrollTop(0);
						self.model.preventNextScrollLimitCheck = false;
					});
				}
			} else {
				this.model.restoreSortIndicatorOnFocus = true;
			}
		},

		updateScrollTop: function(scrollTop){
			if(!this.model.refreshDataInEffect){
				var self = this;
				var state = self.getTypeDependentState();
				if(scrollTop === undefined){
					self.find('base_trees_tree', function(tree){
						if((tree.actualParentComponent || {}).componentIndex !== self.componentIndex) return;
						scrollTop = tree.$.scrollTop();
					});
				}
				if(scrollTop !== undefined){
					state.sortIndicator.scrollTop = scrollTop;
				}
			}
		},

		/**
		 * refreshing the actual trees is working slightly different from the default case implemented in fec/baseComponents/trees/trees.js
		 *
		 * @param restoreTreeState boolean - default: false
		 * @param deselectActiveNode boolean - default: false
		 */
		refreshTrees: function(restoreTreeState, deselectActiveNode){
			if(!restoreTreeState){
				this.model.parentNodeStatesPerType = {};
				this.model.sortIndicatorsPerType = {};
			}
			if(deselectActiveNode){
				this.deselectActiveNode();
				var state = this.getTypeDependentState();
				state.sortIndicator.selectedID 	= undefined;
			}

			this.refreshData();
		},

		onScrollLimitReached: function(endReached){
			if(!this.model.onScrollLimitReached && !this.model.refreshDataInEffect){
				var movingNodeData = this.getSpecialNodeData('dnd');
				if(movingNodeData){
					getComponent('statusController').addPanel('status.routeTrees.refreshTreesWhileDragging', false, 10, 'big');
					return;
				}
				this.model.onScrollLimitReached = true;
				var lastLoadMeta = this.resourceData.meta || {};
				var startLoadGranted = lastLoadMeta.nr_of_pre_indicator_routes !== undefined && lastLoadMeta.nr_of_pre_indicator_routes >= 64;
				var endLoadGranted = lastLoadMeta.nr_of_post_indicator_routes !== undefined && lastLoadMeta.nr_of_post_indicator_routes >= 64;
				var nodeOfInterest;
				var state = this.getTypeDependentState();
				if(endReached && endLoadGranted){
					var lastNode = (this.resourceData.data[this.resourceData.data.length - 1] || {}).attributes || {};
					if((state.sortIndicator.sort || 0) < lastNode.sort){
						nodeOfInterest = lastNode;
					}
				} else if(!endReached && startLoadGranted) {
					for(var d in this.resourceData.data || []){
						var firstVisibleNode = (this.resourceData.data[d] || {}).attributes || {};
						if(firstVisibleNode.visibleInPage){
							if((state.sortIndicator.sort || 0) > firstVisibleNode.sort){
								nodeOfInterest = firstVisibleNode;
							}
							break;
						}
					}
				}

				var refreshing = false;
				if(nodeOfInterest){
					var nodeIndex = this.getNodeIndex(nodeOfInterest.routeID, 'route');
					if(nodeIndex){
						this.backupSortIndicator(nodeOfInterest.routeID, nodeOfInterest.sort, `#${nodeIndex}_anchor`);
						this.refreshData();
						refreshing = true;
					}
				}

				if(!refreshing){
					this.model.onScrollLimitReached = false;
				}
			}
		},

		/**
		 * this function is used to refresh the loaded data according to the new filterValue delayed by the given filterDelay.
		 *
		 * @param filterValue           string - what you want to find
		 * @param filterDelay           int - nr of milliseconds delay
		 */
		search: function(filterValue, filterDelay){
			this.delayedLastOf('search', () => this.refreshData(), filterDelay)
		},

		refreshData: function(){
			this.model.refreshDataInEffect = true;
			this.refresh(true, {refreshResourcesOnly: true});
		}
	},

	hooks: {
		async onDecision($element, options){
			var self = this;

			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent){
								if(modalContentComponent.hasClass('templates_propertiesForms_routeDuplicateOptions')){
									const duplicationOptions = ((modalContentComponent.model.dirtyFields || {}).data || {}).attributes || {}
									duplicationOptions.target = Object.values(duplicationOptions.target || {})[0] || {}
									self.showDuplicate(undefined, undefined, undefined, undefined, { duplicationOptions }).then(function(context){
										options.decisionComponent.hide();
									});
								} else if(modalContentComponent.hasClass('templates_propertiesForms_routePropertiesForm')){
									modalContentComponent.submit().then(function(context){
										options.decisionComponent.hide();
									});
								}
							}
							break;

						case 'templates_layoutTrees_selectLayoutTrees':
							var nodeData    = this.getSelectedNodeData();
							this.edit('edit_route', 'route', 'setLayout', this, {
								routeID: nodeData._primaryKey || nodeData.id,
								templateID: options.data._primaryKey || options.data.id
							}).then(function(context){
								options.decisionComponent.closest('base_modal_modal', async (modalComponent) => {
									await modalComponent.hide()
									self.refreshTrees(true)
								})
							});
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide();
							break;
					}
					break;

				default:
					break;
			}
		},

		postTabFocus: function($element, options){
			if(this.model.restoreSortIndicatorOnFocus){
				this.model.restoreSortIndicatorOnFocus = false;
				this.restoreSortIndicator(true);
			}
		},

		onLanguageConnectorUpdateDone: function($element, options){
			this.model.onScrollLimitReached = false;
			this.refreshData();
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_routePropertiesForm',
			handle: function(callerComponent){
				if(!((callerComponent || {}).config || {}).useArticleMode){
					this.deselectActiveNode();
				}
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_routePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(!((callerComponent || {}).config || {}).useArticleMode){
					// refresh data only in cases where a routePropertiesForm is used within a routeTrees component.
					// mblx-product lists, dynamicAssociatedRoutes like news- or event-routes will never (except for admins) show up within a routeTrees component anyway.
					callerComponent.closest('templates_routeTrees_routeTrees', routeTrees => {
						if(insertPerformed){
							this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
							this.config.readyNodeContext  = 'route';
						}

						this.refreshTrees(true, true);

						// choose layout if necessary
						if(nodeData && nodeData.data && nodeData.data.attributes && !utils.isEmpty(nodeData.data.attributes) && !nodeData.data.attributes.parentRouteID && !nodeData.data.attributes.templateID){
							this.performAndStoreAction(
								'connectLayoutInCharge',
								this.prepareAction('connectLayout_route'),
								true
							);
						}
					}, true)
				}
			}
		},
		{
			name: 'onSuccessfulLoginDialog',
			handle: function(callerComponent){
				// TODO: POI
				// TODO: check if route selector works properly with new error handling cases
				// this.model.refreshDataInEffect = false;
				// this.model.onScrollLimitReached = false;
				// this.refreshData();
			}
		}
	]
};
